module.exports = new __parcel__URL__("teams.fabd4140.png").toString();